program TMSWeb_FormHosting;


{$R *.dres}

uses
  WEBLib.Forms,
  uFrmMain in 'uFrmMain.pas'{*.html},
  uPreview in 'uPreview.pas'{*.html},
  Planta in 'Planta.pas'{*.html},
  LoginFRM in 'LoginFRM.pas'{*.html},
  uSubForm2 in 'uSubForm2.pas'{*.html},
  uGrafico in 'uGrafico.pas'{*.html},
  uTransform in 'uTransform.pas'{*.html},
  uCards in 'uCards.pas'{*.html},
  Unit1 in 'Unit1.pas'{*.html},
  Produtos in 'Produtos.pas'{*.html},
  uLoadTXT in 'uLoadTXT.pas'{*.html};

{$R *.res}

begin
  Application.Initialize;
  Application.MainFormOnTaskbar := True;
  Application.CreateForm(TFrmMain, FrmMain);
  Application.CreateForm(TuPlanta, uPlanta);
  Application.CreateForm(TForm9, Form9);
  Application.CreateForm(TSubForm2, SubForm2);
  Application.CreateForm(TGrafico, Grafico);
  Application.CreateForm(TTransform, Transform);
  Application.CreateForm(TCards, Cards);
  Application.CreateForm(TForm4, Form4);
  Application.CreateForm(TuProdutos, uProdutos);
  Application.CreateForm(TLoadTXT, LoadTXT);
  Application.Run;
end.
